module.exports = __webpack_public_path__ + "static/media/mission (1).7b627c94.png";